import React from 'react'

import { WebApiContextValue } from '../../types/web-api.types'

export const WebApiContext = React.createContext<WebApiContextValue>({})
